export const CRED_TOPUP_PACK = `credits-top-up-pack`;
export const INC_AMT = 50;
export const MAX_CRED_LIMIT = 5000;